import { makeRequest } from "./index";

export async function getSolicitationReport(filters) {
  "blob";
  return await makeRequest(
    "GET",
    "solicitation_export/export",
    null,
    filters,
    "blob"
  );
}

export async function getAverageTimeReport(filters) {
  return await makeRequest(
    "GET",
    "solicitation_average_export/export",
    null,
    filters,
    "blob"
  );
}

export async function getSchedulesReport(filters) {
  return await makeRequest(
    "GET",
    "schedule_export/export",
    null,
    filters,
    "blob"
  );
}

export async function getUserProductivity(filters) {
  return await makeRequest("GET", "productivity_results", null, filters);
}

export async function getNotifications() {
  return await makeRequest("GET", "notifications");
}
